'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import SimilarDesignsSlider from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/components/SimilarDesignsSlider';
import { Locale } from '@/utility/locale';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';
import type { SimilarDesignsResponse } from '../actions/similarDesigns';

export type MostPurchasedRecommendationsProps = {
  shopId: string;
  locale: Locale;
};

const MostPurchasedRecommendations = ({ shopId, locale }: MostPurchasedRecommendationsProps) => {
  const t = useTranslations();

  const { data } = useQuery({
    queryKey: ['mostPurchasedDesigns', shopId, locale],
    queryFn: async () =>
      get<SimilarDesignsResponse>(
        `/internal/api/similarDesigns?${toQueryString({
          locale,
          shopId,
        })}`
      ),
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  const { similarDesigns } = data ?? {};

  if (!similarDesigns?.length) {
    return null;
  }

  return (
    <section className="pb-8 sm:pb-9 md:grid-cols-12 md:pb-12 lg:pb-16 xl:pb-24">
      <h2 className="px-4 text-xl font-bold uppercase sm:px-6 sm:text-2xl md:px-8 md:text-[1.75rem] lg:px-16 lg:text-[2rem] xl:px-22.5">
        {t('mpProductListPage.mostPurchasedDesigns')}
      </h2>
      <SimilarDesignsSlider
        items={similarDesigns}
        tracking={{
          featureUsed: 'product-card-click',
          detail: 'reco most-purchased',
        }}
      />
    </section>
  );
};

export default MostPurchasedRecommendations;
